module.exports = __webpack_public_path__ + "static/media/pic2.4c8eef71.jpg";